import React, { useRef, useState , useEffect,useMemo} from 'react';
import receivableAccountsService from './receivable-accounts.service';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../../software-dynamic/mainSection-multiple-inputs';
import './receivable-accounts.scss'
import securityService from '../../security/security.service';
const CurrencyTransferAdd = (props) => {
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent ,DynamicHiddenInput:HiddenComponent} = 
  { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput};

  const [inputProps, setInputProps] = useState({
  
     AccountID:{name: 'AccountID',   value: props.AccountID || '' },

      AccountCode:{name: 'AccountCode', caption: 'Account Code',  value: props.AccountCode || '',enabled:false },

      AccountTitle:{name: 'AccountTitle', caption: 'AccountTitle',  value: props.AccountTitle || '' },

      AccountTitleShort:{name: 'AccountTitleShort',  value: props.AccountTitleShort || '' },
    
    });
// EXTRA CODE START
// EXTRA CODE END


const updateMainSecionsValue = (valueObj) => {
  setInputProps((prevValues) => {
    const updatedValues = { ...prevValues };

    Object.keys(valueObj).forEach((key) => {
      if (updatedValues[key]) {
        updatedValues[key] = {
          ...updatedValues[key],
          ...valueObj[key], // Ensure it correctly updates the `value`
        };
      }
    });

    console.log("Updated State:", updatedValues); // Debugging
    return updatedValues;
  });
};



const handleInputCreated = async (e, name) => {
  if(name == 'AccountCode' && props.isAdd == true){
    let reponse  = await receivableAccountsService.generateCode(props.CompanyID || securityService.getCompanyIDLoggedInUserId())
    console.log(reponse)
    updateMainSecionsValue({ AccountCode: { value: reponse.data.recordset[0].NewAccountCode || ''} });
  }
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {

    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    {
      Input: HiddenComponent,
      Props: {
        ...inputProps.AccountID, 
        setInputProps },ColumnSize:0
      },
    {
      Input: TextComponent,
      Props: {
        ...inputProps.AccountCode, onCreated:handleInputCreated,
        setInputProps },ColumnSize:12
      },
    {
      Input: TextComponent,
      Props: {
        ...inputProps.AccountTitle, 
        setInputProps },ColumnSize:12
      },
    {
      Input: TextComponent,
      Props: {
        ...inputProps.AccountTitleShort, 
        setInputProps },ColumnSize:12
      },
    
    
    
  ];
//   const FirstGridComponent = useMemo(()=>()=>{
//  return( <StructuredGenerate   mainProps={props} title={'Invoice Evaluation Add'} Inputs={inputsList}/>)
//   },[inputProps])
  return (
    <>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Receivable Accounts ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
    </>
  );
}; 

export default CurrencyTransferAdd;
